<template>
  <b-button
    :variant="variant"
    :disabled="disabled"
    :block="block"
    :type="type"
    class="app-button"
    @click="$emit(appConstants.app.emitEvents.CLICK, $event)"
  >
    <slot>
      <template>{{ text }}</template>
    </slot>
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import appConstants from '@/constants/constants'

export default {
  name: 'AppButton',
  components: { BButton },
  emits: ['click'],
  props: {
    text: {
      type: [String, null],
      required: false,
    },
    variant: {
      type: String,
      required: false,
      default: () => 'primary',
      validator: () => ['primary'],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    block: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    type: {
      type: String,
      required: false,
      default: () => 'text',
    },
  },
  setup() {
    return {
      appConstants,
    }
  },
}
</script>

<style lang='scss' scoped>

.app-button {
  margin: 0;
}

</style>